import {
  largeIconBorderRadius,
  largeIconStyles,
  mediumIconBorderRadius,
  mediumIconStyles,
  mediumIndeterminateStyles,
  smallIconBorderRadius,
  smallIconStyles,
} from './styles';

export const CHECK_SIZE_CLASSES = {
  large: largeIconStyles,
  medium: mediumIconStyles,
  small: smallIconStyles,
};

export const SIZE_BORDER_RADIUS_CLASSES = {
  large: largeIconBorderRadius,
  medium: mediumIconBorderRadius,
  small: smallIconBorderRadius,
};

export const CHECK_ICON_SIZE_CLASSES = {
  large: 'h-16 w-16',
  medium: 'h-14 w-14',
  small: 'h-12 w-12',
};

export const INDETERMINATE_ICON_SIZE_CLASSES = {
  large: 'h-8 w-8',
  medium: mediumIndeterminateStyles,
  small: 'h-6 w-6',
};
